import { configureStore } from '@reduxjs/toolkit';
import onboardReducer from './onboardSlice';
import configReducer from './configSlice';
import kbReducer from './kbSlice';
import fbReducer from './fbSlice';

const store = configureStore({
  reducer: {
    onboard: onboardReducer,
    config: configReducer,
    allKb: kbReducer,
    allFaceBots: fbReducer
  },
});

export default store;
